import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
  input: {
    marginBottom: '20px',
    /*[theme.breakpoints.up('md')]: {
      marginRight: '10px',
      maxWidth: '270px',
    },*/
  },
  textarea: {
    marginBottom: '20px',
    /*[theme.breakpoints.up('md')]: {
      marginRight: '10px',
      maxWidth: '550px',
    },*/
  },
  button: {
    borderRadius: '38px',
    textTransform: 'none',
  },
  tab: {
    root: {
      borderRadius: '10px',
    },
  },
}));
